<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="Yetki" class="float-right">
        <router-link tag="button" to="/muhasebe/kasa/virman" class="el-button YeniBtn el-button--small"
        >Virman
        </router-link>
        <el-button type="info" size="small" class="YeniBtn" @click="this.YeniBtn">{{ Sayfa.ButtonAdi }}
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-table
        v-if="Liste"
        :data="Liste.filter(data => !search || data.Adi.toLowerCase().includes(search.toLowerCase()))"
        :default-sort="{prop: 'Adi', order: 'ascending'}"
        class="golgetable"
        row-key="id"
        :height="Height"
        default-expand-all>
        <el-table-column
          prop="Kod"
          label="Kod"
          width="100">
        </el-table-column>
        <el-table-column
          prop="Adi"
          label="Adi">
        </el-table-column>
        <el-table-column
          prop="BinaAdi"
          label="Site/Bina Adı">
        </el-table-column>
        <el-table-column
          prop="sPosText"
          label="Sanal Pos"
          width="120">
        </el-table-column>
        <el-table-column
          prop="fPosText"
          label="Pos"
          width="120">
        </el-table-column>
        <el-table-column
          prop="Bloke"
          label="Bloke Gün"
          width="100">
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Sayfa.Arama"/>
          </template>
          <template slot-scope="scope">
            <el-button-group>
              <el-tooltip v-if="Yetki" class="item" effect="dark" content="Hareketleri Devret"
                          placement="top-start">
                <i
                  class="feather-shuffle tableibtn text-warning"
                  @click="HareketDevret(scope.row)">
                </i>
              </el-tooltip>
              <el-tooltip v-if="Yetki" class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <i
                  class="feather-edit-2 tableibtn text-primary"
                  @click="DuzenleBtn(scope.row)">
                </i>
              </el-tooltip>
              <el-tooltip v-if="Yetki" class="item" effect="dark"
                          :content="Sayfa.SilAdi"
                          placement="top-start">
                <i
                  class="feather-trash tableibtn text-danger"
                  @click="SilOnay(scope.row.id)">
                </i>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      v-if="HareketDevirModal"
      title="Kasa Hareket Devir İşlemi"
      :visible="HareketDevirModal"
      center
      width="30%">
      <a @click="HareketDevirModal=false" class="ModalKapat"><i class="el-icon-close"></i></a>

      <el-form :model="DevirFormData" @submit.prevent.native="Submit" :rules="DevirFormHata" ref="HareketForm">

        <el-form-item label="Hareketleri Devir Alacak Kasa" prop="dKasa_id">
          <el-cascader
            v-model="DevirFormData.dKasa_id"
            collapse-tags
            placeholder="Kasa Seçiniz"
            :props="{ multiple: false}"
            :options="Liste"
            filterable></el-cascader>
        </el-form-item>

      </el-form>
      <el-alert
        title="Önemli Bilgilendirme"
        type="warning"
        :closable="false"
        :description="HareketSecim.Adi+' Kasasındaki bütün hareketler aşağıda seçtiğiniz kasaya devredilecek ve silinecektir.'"
      >
      </el-alert>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" :loading="lo" size="medium" @click="HareketDevirOnay()" icon="el-icon-check">
          Devret ve <b>{{ HareketSecim.Adi }}</b> Kasasını sil
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="Baslik"
      :visible="ModalOlayi"
      center
      width="50%">
      <a @click="ModalOlayi=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-form :model="FormData" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
        <el-row :gutter="24">
          <el-col :span="8" v-if="!FormData.children">
            <el-form-item label="Üst Kasa" prop="Kasa_id">
              <el-select v-model="FormData.Kasa_id" filterable clearable>
                <el-option
                  v-for="item in Liste"
                  :key="item.id"
                  :label="item.Kod+' '+item.Adi"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Kasa Kodu" prop="Kod">
              <el-input v-model="FormData.Kod"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="FormData.children?20:12">
            <el-form-item label="Kasa Adı" prop="Adi">
              <el-input v-model="FormData.Adi"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-alert
          v-if="FormData.children"
          title="Üst Kasa Olduğu için kısıtlı düzenleme yapabilirsiniz."
          type="info"
          :closable="false"
        ></el-alert>
        <el-row :gutter="24" v-if="!FormData.children">
          <el-col :span="8">
            <el-form-item label="Site / Bina" prop="Bina_id">
              <el-select v-model="FormData.Bina_id" placeholder="Tüm Binalar" filterable clearable>
                <el-option-group
                  label="Site Listesi">
                  <el-option
                    v-for="item in Siteler"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
                <el-option-group
                  label="Bina Listesi">
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Kıdem Tazminatı" prop="Kidem">
              <el-tooltip class="item" effect="dark"
                          content="Kıdem tazminatı için ayrılan paralar"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-switch v-model="FormData.Kidem"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Sanal Pos" prop="sPos">
              <el-tooltip class="item" effect="dark"
                          content="Sanal Pos Kasası"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-switch v-model="FormData.sPos"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item class="Tooltip" label="Fiziksel Pos" prop="fPos">
              <el-tooltip class="item" effect="dark"
                          content="Fiziksel Pos"
                          placement="top">
                <i class="el-icon-info text-primary cursor-pointer"></i>
              </el-tooltip>
              <el-switch v-model="FormData.fPos"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Bloke Gün" prop="Bloke">
              <el-input v-model="FormData.Bloke"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()" icon="el-icon-check">
          {{ $t('eGenel.0') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      lo: false,
      Yetki: false,
      ModalOlayi: false,
      HareketDevirModal: false,
      Baslik: null,
      search: '',
      Height: window.innerHeight - 150,
      Bina_id: null,
      HareketSecim: null,
      Binalar: [],
      Siteler: [],
      Sayfa: {
        ButtonAdi: 'Kasa Ekle',
        DuzenleAdi: this.$t('eGenel.10'),
        SilAdi: this.$t('eGenel.11'),
        Button: null,
        EkranAdi: 'Kasa Detay',
        Adi: 'Kasa Listesi',
        Menu: [],
        MenuDisplay: null,
      },
      Liste: [],
      FormHata: {
        Adi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
      },
      DevirFormHata: {
        dKasa_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
      },
      FormData: {},
      DevirFormData: {
        dKasa_id: null,
        Kasa_id: null
      },
    }
  },
  methods: {
    HareketDevret(Kasa) {
      this.HareketDevirModal = true
      this.HareketSecim = Kasa
      this.DevirFormData.Kasa_id = Kasa.id
      this.DevirFormData.dKasa_id = null
    },
    HareketDevirOnay() {
      this.$refs['HareketForm'].validate((valid) => {
        if (valid) {
          this.$confirm("Bu işlem hiç bir şekilde geri alınamayacaktır. Kasa hareketlerinin devir edilmesini onaylıyormusunuz?", this.$t('eGenel.7'), {
            confirmButtonText: this.$t('eGenel.2'),
            cancelButtonText: this.$t('eGenel.3'),
            type: 'warning'
          }).then(() => {
            this.DevirBaslat()
          }).catch(() => {
            this.$message.info(this.$t('eGenel.8'));
          });
        }
      });
    },
    DevirBaslat() {
      this.$store.dispatch("Post", {
        ...this.DevirFormData,
        path: 'muhasebe/hareketdevir/kasa'
      })
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.SayfaYukle()
            this.$message.success(response.Mesaj);
          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    Submit() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true;
          if (this.FormData.id) {
            // DÜZENLE
            this.$store.dispatch("Put", {
              ...this.FormData,
              path: 'muhasebe/kasa/' + this.FormData.id
            })
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.SayfaYukle()
                  this.$message.success(response.Mesaj);
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })

          } else {
            // EKLE
            this.$store.dispatch("Post", {...this.FormData, path: 'muhasebe/kasa/'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.SayfaYukle()
                  this.$message.success(response.Mesaj);
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        }
      });

    },
    SayfaYukle() {
      this.ModalOlayi = false;
      this.HareketDevirModal = false;
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/kasa/kidem'})
        .then(response => {

          if (response.Durum === 'OK') {
            this.Liste = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });

      this.$store.dispatch("Get", {path: 'yonetim/bina'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.$store.dispatch("Get", {path: 'yonetim/site'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Siteler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.Yetki = this.$store.getters.Yetki.muhasebe == 2 ? true : false;

    },
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.lo = true;
      this.$store.dispatch("Delete", {...this.Form, path: 'muhasebe/kasa/' + id})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.ModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    YeniBtn() {
      this.ModalOlayi = true;
      this.Baslik = 'Kasa Ekle';
      this.FormData = {
        Kasa_id: null,
        Adi: null,
        Bloke: 0,
        Kod: null,
        Demribas: false,
        sGelir: false,
        Bina_id: this.Bina_id,
      }
    },
    DuzenleBtn(Veri) {
      this.FormData = Veri;
      this.Baslik = Veri.Adi + ' Düzenle';
      this.ModalOlayi = true
    },
  },
  created() {
    if (this.$store.getters.BinaBilgi) {
      //this.Bina_id = this.$store.getters.BinaBilgi.id;
    }
    this.$store.commit("SayfaBilgi", this.Sayfa);
    //console.log(this.Sayfa);
    this.SayfaYukle();

  }

}
</script>



// WEBPACK FOOTER //
// src/pages/Muhasebe/kasa/Liste.vue